// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","primary":"Button_primary__XYgy-","outlined":"Button_outlined__gq+aU"};